/* Vedicflora cart drawer enhancement: 2hr delivery banner + free-ship progress bar.
 * Injects above cart contents in the drawer. Updates on every cart change.
 */
(function(){
  var THRESHOLD = 39900;   // ₹399 in paise
  var PINCODE   = '110001';

  function money(p) { return '₹' + Math.round(p/100); }

  function bannerHtml(total) {
    var rem = Math.max(0, THRESHOLD - total);
    var pct = Math.min(100, Math.max(0, (total/THRESHOLD)*100));
    var qual = rem === 0
      ? '🎉 You qualify for FREE delivery'
      : 'Add <strong>' + money(rem) + '</strong> more for FREE delivery';
    return '<div class="vf-drawer-banner" style="background:#f0f9f4;border:1px solid #2e7d32;border-radius:8px;padding:12px 14px;margin:0 0 16px;">'
      + '<div style="font-weight:600;color:#2e7d32;font-size:14px;line-height:1.3;">⚡ Delivers in 2 hours to ' + PINCODE + '</div>'
      + '<div style="font-size:12px;color:#555;margin-top:4px;">' + qual + '</div>'
      + '<div style="width:100%;height:5px;background:#e0e0e0;border-radius:3px;margin-top:8px;overflow:hidden;">'
      + '<div style="width:' + pct.toFixed(1) + '%;height:100%;background:#2e7d32;transition:width 0.4s;"></div>'
      + '</div></div>';
  }

  function inject() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || cart.item_count === 0) {
          var stale = document.querySelector('.vf-drawer-banner');
          if (stale) stale.remove();
          return;
        }
        var target = drawer.querySelector('.drawer__inner-empty')
          || drawer.querySelector('.cart-drawer__form')
          || drawer.querySelector('.drawer__inner')
          || drawer.querySelector('cart-drawer-items')
          || drawer;
        var existing = drawer.querySelector('.vf-drawer-banner');
        if (existing) {
          existing.outerHTML = bannerHtml(cart.total_price);
        } else {
          target.insertAdjacentHTML('afterbegin', bannerHtml(cart.total_price));
        }
      })
      .catch(function(){});
  }

  // Hook Dawn's pub/sub if present
  document.addEventListener('DOMContentLoaded', function(){
    inject();
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, inject);
    }
    // Watch for drawer becoming visible
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var mo = new MutationObserver(inject);
      mo.observe(drawer, { attributes: true, attributeFilter: ['class','open','aria-hidden'] });
    }
    // Intercept fetch on /cart endpoints to re-inject after mutations
    var origFetch = window.fetch;
    window.fetch = function(u, opts){
      var p = origFetch.apply(this, arguments);
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (/\/cart(\/|\.js)/.test(url) && opts && (opts.method||'').toUpperCase() === 'POST') {
        p.then(function(){ setTimeout(inject, 50); }).catch(function(){});
      }
      return p;
    };
  });
})();
